import _ from 'lodash';
import { StringMap } from '../../types/system';

export const parse = (str: string = ''): StringMap<string | undefined> => {
  const result = {};

  if (!str) {
    return result;
  }

  const strArr = (/^[?#]/.test(str) ? str.slice(1) : str).split('&');

  return _.reduce(
    strArr,
    (res, valueSting) => {
      const [key, value] = valueSting.split('=');

      if (key && value) {
        res[key] = value;
      }

      return res;
    },
    result,
  );
};
